import React from 'react'
import PropTypes from 'prop-types'

/**
 * Table body component
 */
const TableBody = ({ className = '', children, ...props }) => (
  <tbody className={className} {...props}>
    {children}
  </tbody>
)

TableBody.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

TableBody.defaultProps = {
  className: ''
}

export default TableBody
